<template>
  <div class="app-package-attachments-uploader">
    <DroppableResumableUploader
      v-bind="$attrs"
      inline
      accept=".obb"
      :upload-url="uploadUrl"
      @upload-done="emitUploadResponse"
    />
  </div>
</template>

<script>
import form from '@/mixins/form';
import DroppableResumableUploader from '@@/common/file-uploaders/DroppableResumableUploader';

export default {
  name: 'AppPackageAttachmentsUploader',

  components: {
    DroppableResumableUploader,
  },

  mixins: [form],

  props: {
    uploadUrl: {
      type: String,
      required: true,
    },
  },

  methods: {
    emitUploadResponse(responses) {
      this.$emit('upload', responses[0]?.data);
    },
  },
};
</script>

<style lang="scss">
.app-package-attachments-uploader {
  margin-top: $global-margin * 2;
}
</style>
